import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col, Table } from 'react-bootstrap';
import Swal from "sweetalert2";
import PoServices from '../../../services/PoServices';

import RequestServies from '../../../services/RequestServies';
import Loader from '../Loader/loader';

const ReceivedOrderModal = ({ show, handleClose, test, admin }) => {

  const [poItems, setPoItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // ================================
  // LOGGED-IN USER (FROM LOCALSTORAGE)
  // ================================
  const userDetails = JSON.parse(localStorage.getItem('userDetails'));
  const loggedInEmail = userDetails?.data?.user?.email;

  // Only this email can cancel

  // ALLOWED EMAILS FOR CANCEL ACTION
  // ================================
  const ALLOWED_CANCEL_EMAILS = [
    'ravidagdi@gmail.com',
    'dineshindigo@gmail.com',
  ];


  const canShowCancelButton = ALLOWED_CANCEL_EMAILS.includes(loggedInEmail);



  // ================================
  // STATUS LABELS (UI ONLY)
  // ================================
  const STATUS_LABELS = {
    approved: 'Order Pending',
    received: 'Received',
    rejected: 'Rejected',
    auto_closed: 'Auto Closed',
    force_closed: 'Force Closed',
    pending: 'Pending',
  };

  const MRV_IMAGE_BASE_URL = "https://indigoinfra.in/img/mrv";


  useEffect(() => {
    if (admin && admin._id && show) {
      fetchPOItems(admin._id);
    }
  }, [admin, show]);

  const fetchPOItems = async (poId) => {
    setLoading(true);
    try {
      const res = await PoServices.AllItemsByPoId(poId);
      setPoItems(res?.data || []);
    } catch (error) {
      console.error('Error fetching PO items:', error);
      Swal.fire('Error', 'Failed to fetch PO items.', 'error');
    } finally {
      setLoading(false);
    }
  };

  // ================================
  // CANCEL REMAINING ORDER
  const handleCancelRemaining = async (item) => {

    const result = await Swal.fire({
      title: 'Cancel Remaining Order?',
      text: 'Please provide the reason for cancellation.',
      icon: 'warning',
      input: 'textarea',
      inputLabel: 'PO Remark',
      inputPlaceholder:
        'Enter cancellation reason...',
      inputAttributes: {
        maxlength: 500
      },
      showCancelButton: true,
      confirmButtonText: 'Yes, Cancel',
      cancelButtonText: 'No',
      inputValidator: (value) => {

        if (!value || !value.trim()) {
          return 'PO Remark is required';
        }

        return null;
      }
    });

    if (!result.isConfirmed) return;

    try {

      await RequestServies.CancelItem(
        item._id,
        {
          poRemark: result.value.trim()
        }
      );

      Swal.fire(
        'Cancelled!',
        'Remaining order has been cancelled.',
        'success'
      );

      fetchPOItems(admin._id);

    } catch (error) {

      console.error(error);

      Swal.fire(
        'Error',
        error?.response?.data?.message ||
        'Failed to cancel remaining order.',
        'error'
      );
    }
  };

  const formatQty = (value, unitObj) => {
    const num = Number(value);
    const qty = isNaN(num) ? '0.00' : num.toFixed(2);

    const unitName =
      typeof unitObj === 'string'
        ? unitObj
        : unitObj?.name || '';

    return unitName ? `${qty} ${unitName}` : qty;
  };


  const handleInvoicePreview = (imageName) => {
    if (!imageName) {
      Swal.fire("No Invoice", "MRV image not available", "info");
      return;
    }

    const imageUrl = `${MRV_IMAGE_BASE_URL}/${imageName}`;
    window.open(imageUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal className="fade" show={show} onHide={handleClose} size="xl" enforceFocus={false}>
      <Modal.Header>
        <Modal.Title>
          <i className="fas fa-edit"></i> Received Order Status
        </Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose}></Button>
      </Modal.Header>

      <Modal.Body>
        <Container fluid>
          <Row>
            <Col md="12">
              {loading ? (
                <Loader />
              ) : poItems.length > 0 ? (
                <div className="scrolltable">
                  <Table striped bordered>
                    <thead className="sticky-table-header">
                      <tr>
                        <th style={{ width: '5%' }}>#</th>
                        <th style={{ width: '12%' }}>Part No</th>
                        <th>Description</th>
                        <th style={{ width: '8%' }}>Qty</th>
                        <th style={{ width: '10%' }}>Received Qty</th>
                        <th style={{ width: '10%' }}>Pending Qty</th>
                        <th className='text-center' style={{ width: '18%' }}>Status</th>
                        <th style={{ width: '12%' }}>MRV No</th>
                        <th style={{ width: '12%' }}>Invoice</th>
                      </tr>
                    </thead>
                    <tbody>
                      {poItems.map((item, idx) => (
                        <tr key={item._id}>
                          <td>{idx + 1}</td>
                          <td>{item?.inventory?.masterItem?.partNo || 'N/A'}</td>
                          <td className="scrollable-description">{item?.inventory?.masterItem?.description || 'N/A'}</td>
                          <td>{formatQty(item?.approveQty, item?.inventory?.masterItem?.unit?.name)}</td>

                          <td>{formatQty(item?.qtyRecived, item?.inventory?.masterItem?.unit?.name)}</td>

                          <td>
                            {(item?.flag === "new" || item?.flag === "remain") &&
                              item?.status?.toLowerCase() === "approved"
                              ? formatQty(
                                item?.approveQty,
                                item?.inventory?.masterItem?.unit?.name
                              )
                              : formatQty(
                                0,
                                item?.inventory?.masterItem?.unit?.name
                              )}
                          </td>

                          {/* ===== STATUS (TOP) + BUTTON (BOTTOM) ===== */}
                          <td>
                            <div className="d-flex flex-column gap-1 text-center">
                              <span className="fw-semibold">
                                {STATUS_LABELS[item.status] || item.status}
                              </span>

                              {item.status === 'approved' && canShowCancelButton && (
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  className="align-self-center"
                                  onClick={() => handleCancelRemaining(item)}
                                >
                                  Cancel Remaining
                                </Button>
                              )}


                            </div>
                          </td>


                          <td>{item?.mrv?.mrvNo || '-'}</td>
                          <td className="text-center">
                            {item?.mrv?.image ? (
                              <i
                                className="fas fa-eye text-primary"
                                style={{ cursor: "pointer", fontSize: "18px" }}
                                title="View MRV Invoice"
                                onClick={() => handleInvoicePreview(item.mrv.image)}
                              ></i>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <p className="text-center text-muted">No PO items available.</p>
              )}
            </Col>
          </Row>
        </Container>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger light" size="sm" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReceivedOrderModal;
